var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "result-wrapper" }, [
    _c("div", { staticClass: "banner insurance" }, [
      _c("div", { staticClass: "container" }, [
        _c("h1", [_vm._v(_vm._s(_vm.t("insurance.title")))]),
        _vm._v(" "),
        _c("h4", {
          staticClass: "desktop-only",
          domProps: { innerHTML: _vm._s(_vm.t("insurance.subtitle")) },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "banner sections" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "blocks" }, [
          _c("h3", {
            domProps: { innerHTML: _vm._s(_vm.t("insurance.subtitle2")) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row home-products items-4" }, [
            _c(
              "div",
              { staticClass: "d-flex" },
              _vm._l(_vm.types, function (item, index) {
                return _c(
                  "nuxt-link",
                  { key: index, attrs: { to: item.path } },
                  [
                    _c("div", { staticClass: "card" }, [
                      _c("h2", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      _c("p", { domProps: { innerHTML: _vm._s(item.desc) } }),
                      _vm._v(" "),
                      _c("img", { attrs: { src: item.image } }),
                    ]),
                  ]
                )
              }),
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }